const ShowChart: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M4.19997 17.78L9.49997 12.48L12.75 15.73C13.16 16.14 13.82 16.12 14.2 15.69L21.37 7.62C21.72 7.23 21.7 6.63 21.33 6.25C20.93 5.85 20.26 5.86 19.88 6.29L13.49 13.47L10.2 10.18C9.80997 9.79 9.17997 9.79 8.78997 10.18L2.69997 16.28C2.30997 16.67 2.30997 17.3 2.69997 17.69L2.78997 17.78C3.17997 18.17 3.81997 18.17 4.19997 17.78Z" fill="currentColor" />
  </svg>
);

export default ShowChart;
